import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import styled from "styled-components"
import { rem } from "polished"
import { Meta } from "@outdoormap/gatsby-plugin-brand-sites"

import Layout from "../components/layout"
import TypeHero from "../components/type-hero"
import SitesGrid from "../components/sites-grid"
import Map from "../components/map"
import { typesCategories } from "../config/type"

const collectCategories = (data) => {
  const categories = {}
  data.nodes.forEach(
    (n) => n.mainCategory && (categories[n.mainCategory.id] = n.mainCategory)
  )
  return Object.values(categories)
}

const TypeTemplate = ({ data: { config, sites } }) => {
  const type = config.types[0]
  const categories = useMemo(() => collectCategories(sites), [sites])

  const filteredSites = useMemo(() => {
    if (type.name === `more`) {
      return sites.nodes.filter((site) => {
        const allCategories = Object.values(typesCategories).reduce(
          (allCategories, categoryValues) => {
            allCategories = [...allCategories, ...categoryValues]
            return allCategories
          },
          []
        )

        return !allCategories.includes(site.theType)
      })
    } else {
      return sites.nodes
    }
  })

  const mapQuery = [
    `guide=${process.env.GATSBY_NATURKARTAN_GUIDE_ID}`,
    ...categories.map((c) => `category=${c.id}`),
  ].join(`&`)

  return (
    <Layout>
      <TypeHero
        type={type}
        // mapPreselectedCategories={categories.map((c) => c.slug).join(`,`)}
      >
        <Map
          query={mapQuery}
          menu="fullscreen"
          scrollZoom="false"
          styleControl="fullscreen"
          zoomControl="true"
          measureControl="fullscreen"
          locationControl="fullscreen"
          printControl="fullscreen"
          legendControl="true"
          legend="true"
        />
      </TypeHero>

      <SitesGridWrap>
        <SitesGrid data={filteredSites} type={type} />
      </SitesGridWrap>
    </Layout>
  )
}

TypeTemplate.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
}

export default TypeTemplate

export const Head = ({ data: { config } }) => {
  const type = config.types[0]

  return <Meta data={{ title: type.title, description: type.tagline }} />
}

export const pageQuery = graphql`
  query ($type: String!, $categories: [String]!) {
    config: configJson {
      types(name: $type) {
        name
        slug
        color
        title
        tagline
        description
      }
    }

    sites: allSitesJson(
      filter: { categories: { elemMatch: { nk_id: { in: $categories } } } }
      sort: { name: ASC }
    ) {
      nodes {
        ...SitesCardFragment

        categories {
          id: nk_id
        }
      }
    }
  }
`

const SitesGridWrap = styled.div`
  margin-top: ${rem(40)};
  margin-bottom: ${rem(40)};

  @media ${({ theme }) => theme.mq.mediumDown} {
    margin-top: ${rem(30)};
    margin-bottom: ${rem(30)};
  }
`
